import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const SessionExpiredAlert = ({ onRelogin }) => {
  const [visible, setVisible] = useState(true);

  return (
    <Dialog 
      header="Session Expired" 
      visible={visible} 
      onHide={() => setVisible(false)} 
      modal 
      closable={false} 
      draggable={false} 
      resizable={false} 
      style={{ width: "30vw", textAlign: "center" }}
    >
      <p>Your session has expired. Please log in again to continue.</p>
      <Button 
        label="Re-Login" 
        icon="pi pi-sign-in" 
        className="p-button-danger" 
        onClick={onRelogin} 
      />
    </Dialog>
  );
};

export default SessionExpiredAlert;
